import { useEffect, useRef, useState } from "react";
import { Prompt } from "react-router-dom";
import {
    useHistory,
    useParams,
    useLocation
} from "react-router-dom";
import Field from "./Field";
import { firestore } from "./firebase";
import queryString from "query-string";
import { toast } from "react-toastify";


export default function Location() {
    const ref = useRef();

    const history = useHistory();
    const l = useLocation();

    const [queryParams, setQueryParams] = useState({});
    useEffect(() => setQueryParams(queryString.parse(l.search)), [l.search]);

    const { id } = useParams();

    const [data, setData] = useState({});
    const [location, setLocation] = useState(null);

    const [unsavedChanges, setUnsavedChanges] = useState(false);
    
    const [address, setAddress] = useState(null);
    const [postalCode, setPostalCode] = useState(null);
    const [city, setCity] = useState(null);
    
    useEffect(() => JSON.stringify(data) !== JSON.stringify(location?.data()) ? setUnsavedChanges(true) : setUnsavedChanges(false), [data, location]);
    useEffect(() => firestore.collection('locations').doc(id).get().then(document => {
        setData(document.data());
        setLocation(document);
        ref.current.scrollTop = 0;
    }), [id]);

    useEffect(() => {
        const splitAddress = location?.data()?.address?.split(', ');
        setAddress(splitAddress?.length > 0 ? splitAddress[0] : '');
        setPostalCode(splitAddress?.length > 0 ? splitAddress[1] : '');
        setCity(location?.data()?.city??(splitAddress?.length > 0 ? splitAddress[2] : ''));
    }, [location]);

    const back = () => {
        if(!queryParams.return) return false;
        history.push(queryParams.return);
        return true;
    }

    const save = async () => {
        if(address && postalCode && city)
            data.address = address + ', ' + postalCode + ', ' + city.charAt(0).toUpperCase() + city.slice(1);
        else if(address)
            data.address = address;
        if(city)
            data.city = city;
        await firestore.collection('locations').doc(id).set(data, { merge: true });
        setUnsavedChanges(false);
        toast.success("Speichern erfolgreich", {theme: "dark"})
    };

    const remove = async () => {
        if(!window.confirm('Bist du dir sicher, dass du diesen Eintrag löschen willst?')) return;
        await firestore.collection('locations').doc(id).delete();
        toast.success("Löschen erfolgreich", {theme: "dark"})
        history.push('/locations');
    };

    return <div className="h-full flex flex-col">
        <Prompt message="Einige Änderungen wurden noch nicht gespeichert. Trotzdem fortfahren?" when={unsavedChanges} />
        <div className="bg-gray-500 flex flex-col md:flex-row gap-2 p-4 md:py-0 md:px-2">
            <button className="bg-gray-400 px-6 py-1 md:py-2 rounded md:rounded-b-none md:rounded-t md:mt-2 md:font-semibold" onClick={back}>Zurück</button>
            <button className="bg-blue-500 px-6 py-1 md:py-2 rounded md:rounded-b-none md:rounded-t md:mt-2 md:font-semibold text-white" onClick={save}>Änderungen speichern</button>
            <button className="bg-gray-400 px-6 py-1 md:py-2 rounded md:rounded-b-none md:rounded-t md:mt-2 md:font-semibold" onClick={remove}>Location löschen</button>
        </div>
        {
            id && location ? <div className="p-3 overflow-scroll" key={location.id} ref={ref}>
                <div className="font-bold">Metadaten</div>
                <div className="flex-col md:flex-row flex my-1">
                    <div className="w-64">ID:</div>
                    <div className="w-64">{id}</div>
                </div>
                <div className="flex-col md:flex-row flex my-1">
                    <div className="w-64">Erstellt:</div>
                    <div className="w-64">{location?.data()?.created_timestamp?.toDate()?.toLocaleString('de-DE')}</div>
                </div>
                <div className="flex-col md:flex-row flex my-1">
                    <div className="w-64">Zuletzt bearbeitet von:</div>
                    <div className="w-64">{location?.data()?.agent}</div>
                </div>
                {location?.data()?.partner && <div className="flex-col md:flex-row flex my-1">
                    <div className="w-64">Erstellt mit Partner-Formular:</div>
                    <div className="w-64">{location?.data()?.partner}</div>
                </div>}
                <div className="font-bold mt-3 pt-3 border-t-2">Daten</div>
                <Field name="Genereller Typ" value={data?.type??'standard'} type="dropdown" options={['standard','venue']} onChange={(val) => setData({...data, ...{type: val}})} />
                <Field name="Name" value={data?.name} onChange={(val) => setData({...data, ...{name: val}})} />
                <Field name="Straße + Hausnummer" value={address} onChange={(val) => setAddress(val)} />
                <Field name="Postleitzahl" value={postalCode} onChange={(val) => setPostalCode(val)} />
                <Field name="Stadt" value={city} type="city" allowOther={true} onChange={(val) => setCity(val)} />
            </div> : <div className="p-3">
                Bitte warten...
            </div>
        }
    </div>;
}